<template>
  <form @submit.prevent="addBundleToCart" novalidate>
    <slot></slot>
  </form>
</template>

<script>
import { mapGetters } from "vuex";
import { TablescapeContext, TablescapeEvent } from "@tablescape/context";

export default {
  name: "product-bundle-form",
  props: {
    bundletitle: String,
    bundleprice: [Number, String],
  },
  computed: {
    ...mapGetters({
      getProperties: "metafields/getProperties",
    }),
  },
  methods: {
    async addBundleToCart() {
      const checkboxes = document.querySelectorAll(
        "[data-option-radio] .checkbox:checked"
      );
      const selectedVariants = [];
      for (let i = 0; i < checkboxes.length; i++) {
        selectedVariants.push(checkboxes[i].dataset.vid);
      }
      const items = selectedVariants.map((variant) => ({
        attributes: [...(this.getProperties(variant) ?? [])],
        id: variant,
        quantity: 1,
      }));
      TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
        ui: {
          cartDrawerOpen: true,
          cartDrawerUserToggled: false,
          giftNoteDrawerOpen: false,
          productVariantDrawerOpen: false,
        },
      });
      TablescapeContext.emit(TablescapeEvent.ADD_BUNDLE_TO_CART, {
        cart: {
          lines: items,
          bundleProduct: {
            title: this.bundletitle,
            price: this.bundleprice,
          },
        },
      });
    },
  },
  async created() {
    this.$store.dispatch("metafields/fetchMeta");
  },
};
</script>
